import { put, call, takeLatest } from 'redux-saga/effects';
import * as types from './constants';
import * as services from 'services/digitalAsset';
import * as actions from './actions';

export function* saveAssetSaga(action) {
  try {
    const { payload } = action;
    yield call(services.updateDigitalAsset, payload);
    yield put(actions.finishEditAsset());
  } catch (error) {
    yield put(actions.cancelEditAsset());
  }
}

export default function* watchGlobal() {
  yield takeLatest(types.SAVE_ASSET_FULL, saveAssetSaga);
}
